/**
 * Cut to a fixed number of lines, and keep the room for them whether they are
 * filled or not.
 *
 * Both halves matter for a row of cards: the clamp stops one long title
 * pushing everything below it down, and the reserved height stops a short one
 * pulling everything up. Cards side by side whose bands move are a row the eye
 * has to read card by card instead of running down it.
 *
 * `em` rather than pixels, so the box follows the type it holds. Anything cut
 * should carry a `title`, since the whole of it is then one hover away.
 */
export function clampedToLines(lines, lineHeight) {
  return {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: lines,
    overflow: 'hidden',
    lineHeight,
    minHeight: `${(lines * lineHeight).toFixed(2)}em`,
  };
}
